import { CAMPAIGNS_LOADING, CAMPAIGNS_LOADED, CAMPAIGNS_ERROR } from './type';
const initial = { loading: false, items: [], total: 0, page: 1, error: '' };
export default function documentCampaign(state = initial, action) {
  switch (action.type) {
    case CAMPAIGNS_LOADING: return { ...state, loading: true, error: '' };
    case CAMPAIGNS_LOADED: return { ...state, ...action.payload, loading: false, error: '' };
    case CAMPAIGNS_ERROR: return { ...state, loading: false, error: action.error };
    default: return state;
  }
}
